module.exports = __webpack_public_path__ + "img/TD.6f3d9181.svg";